import React from 'react';
import { KPI_LABELS } from '../constants/config';

function KPICard({ title, value, kind }) {
  return (
    <div className={`kpi-card kpi-card-${kind}`}>
      <div className="kpi-content">
        <div className="kpi-label">{title}</div>
        <div className="kpi-number">{value}</div>
        <div className="kpi-badge">{KPI_LABELS[kind] || kind.toUpperCase()}</div>
      </div>
    </div>
  );
}

export default KPICard;
